<template>
    <div :dir="$dir.value">
        <Toaster />
        <NuxtRouteAnnouncer />
        <NuxtLoadingIndicator :color="false" :height="4" class="bg-linear-to-r from-primary to-accent" />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup>
import { Toaster } from "@/components/ui/sonner";
import "vue-sonner/style.css";
</script>
